<template>
    <div>
        <div class="mt-5">
            <h2 class="text-center text-muted">
                ¡ Muchas gracias por tu solicitud ¡
            </h2>
            <h5 class="text-center">
                Un ejecutivo de credito se comunicara contigo en breve.
            </h5>
        </div>
        <div class="form-group mt-5">
            <a
                class="btn btn-block text-uppercase"
                href="/compra_de_usados"
            >
                Visita nuestro inventario
                <span class="angle_arrow"
                    ><i class="fa fa-angle-right" aria-hidden="true"></i
                ></span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    
};
</script>

<style lang="scss"></style>
